/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Editor_TitleInputs */

const en_dialog_text_to_audio_editor_title = /** @type {(inputs: Dialog_Text_To_Audio_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Audio`)
};

const es_dialog_text_to_audio_editor_title = /** @type {(inputs: Dialog_Text_To_Audio_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a Audio`)
};

/**
* | output |
* | --- |
* | "Text to Audio" |
*
* @param {Dialog_Text_To_Audio_Editor_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_editor_title = /** @type {((inputs?: Dialog_Text_To_Audio_Editor_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Editor_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_editor_title(inputs)
	return en_dialog_text_to_audio_editor_title(inputs)
});